var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "80px", "label-position": "left" } },
        [
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.FileType") }
            },
            [
              _c("cargo-advance-select", {
                staticStyle: { width: "100%" },
                attrs: {
                  filterable: "",
                  "select-type":
                    _vm.selectTypeNames.basic_data_TransmitFileType,
                  "default-value": _vm.oneFormData.fileType,
                  disabled: true,
                  "method-params": { lob: _vm.job.lob },
                  "callback-params": { key: "fileType" }
                },
                on: { parentCallBack: _vm.setFileTypeSelectValue }
              })
            ],
            1
          ),
          _vm.backableShow
            ? [
                _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { label: _vm.$t("SeaExport.Back") }
                  },
                  [
                    _c("el-checkbox", {
                      model: {
                        value: _vm.cbBack,
                        callback: function($$v) {
                          _vm.cbBack = $$v
                        },
                        expression: "cbBack"
                      }
                    })
                  ],
                  1
                ),
                _vm.cbBack
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ReceivingDate") }
                      },
                      [
                        _c("el-date-picker", {
                          attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                          model: {
                            value: _vm.oneFormData.backDate,
                            callback: function($$v) {
                              _vm.$set(_vm.oneFormData, "backDate", $$v)
                            },
                            expression: "oneFormData.backDate"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.TenBitCode") }
            },
            [
              _c("el-input", {
                attrs: { "max-length": "10" },
                on: { change: _vm.tenDigitCodeChangeHandler },
                model: {
                  value: _vm.oneFormData.tenDigitCode,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "tenDigitCode", $$v)
                  },
                  expression: "oneFormData.tenDigitCode"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.OperatingCompany") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.oneFormData.companyCname,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "companyCname", $$v)
                  },
                  expression: "oneFormData.companyCname"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.FileNo") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.oneFormData.fileNo,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "fileNo", $$v)
                  },
                  expression: "oneFormData.fileNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.CustomsBroker") }
            },
            [
              _c("cargo-advance-select", {
                attrs: {
                  "select-type": _vm.selectTypeNames.basic_data_Company,
                  "data-filter-function": _vm.customsBrokerFilter,
                  filterable: "",
                  "default-value": _vm.oneFormData.customsBroker || "",
                  "method-params": { customsBroker: true, active: true }
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.oneFormData.customsBroker = p.value
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.TakeByCustomsBroker") }
            },
            [
              _c("el-checkbox", {
                model: {
                  value: _vm.oneFormData.tax,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "tax", $$v)
                  },
                  expression: "oneFormData.tax"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.CustomsDeclarationPages") }
            },
            [
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: {
                  min: 1,
                  max: 9999,
                  precision: 0,
                  "controls-position": "right"
                },
                model: {
                  value: _vm.oneFormData.customsPageNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "customsPageNumber", $$v)
                  },
                  expression: "oneFormData.customsPageNumber"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "custom" },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.oneFormData.customsTransfer,
                    callback: function($$v) {
                      _vm.$set(_vm.oneFormData, "customsTransfer", $$v)
                    },
                    expression: "oneFormData.customsTransfer"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsTransitOrNot")))]
              ),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.oneFormData.commodityInspection,
                    callback: function($$v) {
                      _vm.$set(_vm.oneFormData, "commodityInspection", $$v)
                    },
                    expression: "oneFormData.commodityInspection"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspectionOrNot")))]
              ),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.oneFormData.spotInspection,
                    callback: function($$v) {
                      _vm.$set(_vm.oneFormData, "spotInspection", $$v)
                    },
                    expression: "oneFormData.spotInspection"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsInspectionOrNot")))]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.TradeMethod") }
            },
            [
              _c(
                "el-select",
                {
                  model: {
                    value: _vm.oneFormData.tradeMode,
                    callback: function($$v) {
                      _vm.$set(_vm.oneFormData, "tradeMode", $$v)
                    },
                    expression: "oneFormData.tradeMode"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.All"), value: 0 }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.GeneralTrade"), value: 1 }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.Processing"), value: 2 }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.FeedingCounterparts"),
                      value: 3
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.SamplesOfAdvertisingProducts"),
                      value: 4
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.OtherImportsFree"),
                      value: 5
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.Remarks") }
            },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 3 },
                model: {
                  value: _vm.oneFormData.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "remark", $$v)
                  },
                  expression: "oneFormData.remark"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.CustomerName") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.oneFormData.receiveCompany,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "receiveCompany", $$v)
                  },
                  expression: "oneFormData.receiveCompany"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.ContactPerson") }
            },
            [
              _vm.isSe
                ? _c("cargo-advance-select", {
                    attrs: {
                      "select-type": _vm.selectTypeNames.static_data_Contact,
                      "allow-create": true,
                      filterable: "",
                      cache: false,
                      "default-value": _vm.oneFormData.receivePerson,
                      "static-options": _vm.contactList
                    },
                    on: { parentCallBack: _vm.contactChange }
                  })
                : _vm._e(),
              !_vm.isSe
                ? _c("el-input", {
                    model: {
                      value: _vm.oneFormData.receivePerson,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "receivePerson", $$v)
                      },
                      expression: "oneFormData.receivePerson"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.Tel") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.oneFormData.receiveTel,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "receiveTel", $$v)
                  },
                  expression: "oneFormData.receiveTel"
                }
              })
            ],
            1
          ),
          _vm.isSe
            ? _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.AddressOfContact") }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.oneFormData.receiveAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.oneFormData, "receiveAddress", $$v)
                      },
                      expression: "oneFormData.receiveAddress"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticClass: "custom",
              attrs: { label: _vm.$t("SeaExport.CustomerAddress") }
            },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 3 },
                model: {
                  value: _vm.oneFormData.expressAddress,
                  callback: function($$v) {
                    _vm.$set(_vm.oneFormData, "expressAddress", $$v)
                  },
                  expression: "oneFormData.expressAddress"
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.enterHandler } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.isCustomsStatusTitle,
            title: _vm.$t("SeaExport.StatusOfCustomsDeclaration"),
            width: "600px",
            "append-to-body": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.isCustomsStatusTitle = $event
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "300px" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptionsCustomsStatus,
              "column-defs": _vm.columnDefsCustomsStatus,
              "row-data": _vm.rowDataCustomsStatus
            },
            on: {
              gridReady: function(params) {
                return (_vm.gridApiFileDetail = params.api)
              }
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.isCustomsStatusTitle = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }